import React from 'react';
import { Search, Package, Camera, Plus } from 'lucide-react';
import AssetCard from './AssetCard';

const AssetsList = ({ assets, filteredAssets, loading, searchTerm, setSearchTerm, showScanner, setShowScanner, setShowAddAsset, hasPermission, buildings, setSelectedAsset, openEditModal, openHistoryModal }) => (
  <>
    {/* Action buttons */}
    {hasPermission("view_asset_details") && (
      <div className="flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-3 sm:gap-2">
        <button
          onClick={() => setShowScanner(!showScanner)}
          className="bg-blue-600 text-white px-6 py-3 sm:px-4 sm:py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 transition-colors min-h-[48px] text-base sm:text-sm font-medium"
        >
          <Camera size={20} className="sm:w-4 sm:h-4" />
          <span>Scan QR</span>
        </button>
        {hasPermission("edit_asset_details") && (
          <button
            onClick={() => setShowAddAsset(true)}
            className="bg-blue-600 text-white px-6 py-3 sm:px-4 sm:py-2 rounded-lg hover:bg-blue-700 flex items-center justify-center gap-2 transition-colors min-h-[48px] text-base sm:text-sm font-medium"
          >
            <Plus size={20} className="sm:w-4 sm:h-4" />
            <span>Add Asset</span>
          </button>
        )}
      </div>
    )}

    {/* Search */}
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
      <input
        type="text"
        placeholder="Search assets..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent"
      />
    </div>

    {/* Asset Grid */}
    {loading ? (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto" style={{ borderColor: "#00C5CB" }}></div>
        <p className="text-gray-500 mt-4">Loading assets...</p>
      </div>
    ) : filteredAssets.length === 0 ? (
      <div className="text-center py-12">
        <Package className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No assets found</h3>
        <p className="mt-1 text-sm text-gray-500">
          {searchTerm ? "Try a different search term" : "Get started by creating your first asset"}
        </p>
      </div>
    ) : (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredAssets.map(asset => <AssetCard key={asset.id} asset={asset} buildings={buildings} setSelectedAsset={setSelectedAsset} openEditModal={openEditModal} openHistoryModal={openHistoryModal} hasPermission={hasPermission} />)}
      </div>
    )}
  </>
);

export default AssetsList;
